"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let InvoiceRecord = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.invoice_number = "";
    this.title = "";
    this.operator_name = "";
    this.invoice_type = "";
    this.invoice_type_name = "";
    this.invoice_amount = 0;
    this.created_time = 0;
    this.updated_time = 0;
    this.consignee = "";
    this.status = 0;
    this.status_name = "";
    this.phone = "";
    this.address = "";
    this.operator_guid = "";
    this.invoice_time = 0;
    this.invoice_file = "";
  }
};
InvoiceRecord.model = "invoice.list";
InvoiceRecord = __decorateClass([
  Annotation.ModelMeta
], InvoiceRecord);
